import { theme } from 'lib/theme';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { ViewWithSeparators } from './ViewWithSeparators';

interface Props {
  marginTop?: boolean;
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
}

export const CardGeneric: React.FC<Props> = ({
  children,
  marginTop = false,
  style,
}) => (
  <View
    style={[
      styles.view,
      marginTop ? styles.viewWithMarginTop : undefined,
      style,
    ]}
  >
    <ViewWithSeparators separator={<View style={{ height: theme.padding }} />}>
      {children}
    </ViewWithSeparators>
  </View>
);

const styles = StyleSheet.create({
  view: {
    borderRadius: 8,
    overflow: 'hidden',
    paddingHorizontal: theme.padding * 2,
  },
  viewWithMarginTop: {
    marginTop: theme.paddingVertical / 2,
  },
});
